import { createAction } from '@reduxjs/toolkit';

export const assignRoleStart = createAction<{ userId?: string; roles?: string[] }>(
  'SETTINGS/TEAM/ASSIGN_ROLE_START'
);
export const assignRoleSuccess = createAction<{ userId?: string; roles?: string[] }>(
  'SETTINGS/TEAM/ASSIGN_ROLE_SUCCESS'
);
export const assignRoleFailure = createAction<{ userId?: string; roles?: string[] }>(
  'SETTINGS/TEAM/ASSIGN_ROLE_FAILURE'
);

export const unassignRoleStart = createAction<{ userId?: string; roles?: string[] }>(
  'SETTINGS/TEAM/UNASSIGN_ROLE_START'
);
export const unassignRoleSuccess = createAction<{ userId?: string; roles?: string[] }>(
  'SETTINGS/TEAM/UNASSIGN_ROLE_SUCCESS'
);
export const unassignRoleFailure = createAction<{ userId?: string; roles?: string[] }>(
  'SETTINGS/TEAM/UNASSIGN_ROLE_FAILURE'
);
